import { createAction, props } from '@ngrx/store';
import {
  PagedDiagnosticDTechRemoteAssistanceCustomerDto,
  PagedRemoteAssistanceVehiclesDto,
} from '@services/api/api.service';
import { PagedRemoteServiceListDto, RemoteServiceConsentDto } from '@services/api/sdf-remote-services-api.service';

// --------------------------------
// DEALER D-TECH REMOTE
// --------------------------------

export const setDTechRemoteAssistancesLoading = createAction(
  'setDTechRemoteAssistancesLoading',
  props<{ isLoading: boolean }>(),
);

export const setDTechRemoteAssistancesCompletedLoading = createAction(
  'setDTechRemoteAssistancesCompletedLoading',
  props<{ isLoading: boolean }>(),
);

export const setDTechRemoteAssistancesFilters = createAction(
  'setDTechRemoteAssistancesFilters',
  props<{ filters: { qSearch?: string, startDate?: Date, endDate?: Date } }>(),
);

export const setDTechRemoteAssistancesCompletedFilters = createAction(
  'setDTechRemoteAssistancesCompletedFilters',
  props<{ filters: { qSearch?: string, startDate?: Date, endDate?: Date } }>(),
);

export const setDTechRemoteAssistancesPaginator = createAction(
  'setDTechRemoteAssistancesPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setDTechRemoteAssistancesCompletedPaginator = createAction(
  'setDTechRemoteAssistancesCompletedPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setDTechRemoteAssistancesList = createAction(
  'setDTechRemoteAssistancesList',
  props<{ response: PagedRemoteServiceListDto; }>(),
);

export const setDTechRemoteAssistancesCompletedList = createAction(
  'setDTechRemoteAssistancesCompletedList',
  props<{ response: PagedRemoteServiceListDto; }>(),
);

export const getDTechRemoteAssistancesList = createAction(
  'getDTechRemoteAssistancesList',
);

export const getDTechRemoteAssistancesCompletedList = createAction(
  'getDTechRemoteAssistancesCompletedList',
);

export const obtainWsDTechRemoteAssistanceStatus = createAction(
  'obtainWsDTechRemoteAssistanceStatus',
  props<{ vin: string; assistanceId: string }>(),
);

export const destroyWsDTechRemoteAssistanceStatus = createAction(
  'destroyWsDTechRemoteAssistanceStatus',
);

export const setDTechRemoteAssistanceStatus = createAction(
  'setDTechRemoteAssistanceStatus',
  props<{ status: any; key: string }>(),
);

export const setDTechRemoteAssistanceConsent = createAction(
  'setDTechRemoteAssistanceConsent',
  props<{ consent: RemoteServiceConsentDto | null }>(),
);

// --------------------------------
// CUSTOMER D-TECH REMOTE
// --------------------------------

export const setCustomerVehiclesLoading = createAction(
  'setCustomerVehiclesLoading',
  props<{ isLoading: boolean }>(),
);

export const setDTechRemoteAssistancesCustomerLoading = createAction(
  'setDTechRemoteAssistancesCustomerLoading',
  props<{ isLoading: boolean }>(),
);

export const setCustomerVehiclesFilters = createAction(
  'setCustomerVehiclesFilters',
  props<{ filters: { qSearch?: string } }>(),
);

export const setDTechRemoteAssistancesCustomerFilters = createAction(
  'setDTechRemoteAssistancesCustomerFilters',
  props<{ filters: { qSearch?: string, isCompleted?: boolean, startDate?: Date, endDate?: Date } }>(),
);

export const setCustomerVehiclesPaginator = createAction(
  'setCustomerVehiclesPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setDTechRemoteAssistancesCustomerPaginator = createAction(
  'setDTechRemoteAssistancesCustomerPaginator',
  props<{ paginator: { page: number, pageSize: number } }>(),
);

export const setCustomerVehiclesList = createAction(
  'setCustomerVehiclesList',
  props<{ response: PagedRemoteAssistanceVehiclesDto; }>(),
);

export const setDTechRemoteAssistancesCustomerList = createAction(
  'setDTechRemoteAssistancesCustomerList',
  props<{ response: PagedDiagnosticDTechRemoteAssistanceCustomerDto; }>(),
);

export const getCustomerVehiclesList = createAction(
  'getCustomerVehiclesList',
);

export const getDTechRemoteAssistancesCustomerList = createAction(
  'getDTechRemoteAssistancesCustomerList',
);
